define('v3/Common/Components/SubMenu/SubMenu.Component',[
	'jquery',
	'knockout',
	'module',
	'lodash',
	'env',
	'trackingService',
	'v3/Common/Models/enums',
	'v3/Common/Services/Frontend/Frontend.Service',
	'v3/Common/ViewModels/Navigation/ActiveClassInDevicePoolLinkViewModel',
	'text!v3/Common/Components/SubMenu/SubMenu.Component.html',
	'v3/Common/Components/Survey/Survey.Component',
	'v3/FromV2/backendChangeClass',
	'v3/Common/Bindings/SvgIcon.Binding',
	'v3/Common/Bindings/Badge.binding'
], function ($, ko, module, _, env, trackingService, enums,
	frontend, ActiveClassInDevicePoolLinkViewModel, htmlString, SurveyViewModel, backendChangeClass) {
	function SubMenuViewModel () {
		var self = this;
		var config = module.config();

		self.enums = enums;
		self.userInfo = env.userInfo;
		self.applicationSettings = env.applicationSettings;
		self.actions = config.actions;
		self.classes = ko.observableArray(self.userInfo.classes);
		self.hasSurvey = env.userInfo.hasSurvey;
		self.isSurveyCompleted = ko.observable(!env.userInfo.hasSurvey());
		self.classId = env.userInfo.classId;

		self.notificationCount = ko.computed(function () {
			return parseInt(self.hasSurvey()
				? self.userInfo.notificationCount() + 1
				: self.userInfo.notificationCount());
		});

		var selectedClassModel = _.find(self.userInfo.classes, { id: self.userInfo.classId });
		self.selectedClassWowStage = selectedClassModel ? selectedClassModel.wowStage : null;
		self.subtitle = self.userInfo.gradeName;

		self.selectedClass = ko.observable(self.userInfo.classId);
		self.selectedClass.subscribe(function (newClassId) {
			if (newClassId !== self.userInfo.classId) {
				backendChangeClass.changeClass(newClassId)
					.then(function () {
						window.location = '/V4/' + newClassId;
					});
			}
		});

		self.openSubmenu = function (element, e) {
			frontend.popover.show(e, {
				placement: 'se',
				backdrop: false,
				className: 'popover submenu-popover submenu-popover-fixed',
				viewModel: self,
				template: 'subMenu',
				appendTo: 'nav.menu'
			});
		};

		self.openSurvey = function () {
			SurveyViewModel.viewModel.prototype.openSurvey(true);
			self.popover.close();
		};

		self.openDevicePooling = function (element) {
			element.popover.close();

			var activeClassInDevicePool = new ActiveClassInDevicePoolLinkViewModel();
			frontend.modal.show({
				title: Strings.SetActiveClassInDevicePoolDialogTitle,
				viewModel: activeClassInDevicePool,
				template: 'activeClassInDevicePoolDialog',
				icon: 'Alert',
				modalClass: 'modal dialog',
				width: 500
			});
		};

		self.navigateToQuiz = function () {
			window.location = '/V4/' + self.classId + '/quiz';
		};

		self.onInnovationBoardClick = function () {
			window.open('https://oplossingen.snappet.nl/', '_blank', 'noopener');
			trackingService.sendAction('settings', 'settings_innovation_board_clicked');
		};

		setTimeout(function () {
			$(window).trigger('resize');
		}, 0);

		self.logOff = function () {
			localStorage.removeItem('access_token');
			localStorage.removeItem('impersonate_token');

			for (var i = 0; i < localStorage.length; i++) {
				if (localStorage.key(i).indexOf('dashboard_') !== -1) {
					localStorage.removeItem(localStorage.key(i));
				}
			}

			window.location.assign(config.actions.LogOff);
		};
	}

	return { viewModel: SubMenuViewModel, template: htmlString };
});

